import { apiGet, apiPost } from '../../utils';

export function getAllUsersAPI(data) {

    return apiGet(`api/v1/user/getMobileUser`, data);
}

export function updateNotificationAPI(data) {
    return apiPost('api/v1/user/sendNotification', data);
}